import { render, staticRenderFns } from "./UpdatePasswordForm.vue?vue&type=template&id=8b6fc3f0&scoped=true&"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePasswordForm.vue?vue&type=style&index=0&id=8b6fc3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6fc3f0",
  null
  
)

export default component.exports